import { WISHLISTS_SDK_EVENTS } from "./constants";

class WishlistsSdkEvents
    implements Record<WISHLISTS_SDK_EVENTS, WISHLISTS_SDK_EVENTS>
{
    public readonly WISHLIST_ITEM_CREATED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;
    public readonly WISHLIST_ITEM_DELETED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED;
    public readonly WISHLIST_ITEM_ADDED_TO_CART =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_ADDED_TO_CART;

    /** @deprecated Use WISHLIST_ITEM_CREATED instead. */
    public readonly [WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED] =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;

    /** @deprecated Use WISHLIST_ITEM_DELETED instead. */
    public readonly [WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED] =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED;

    /** @deprecated Use WISHLIST_ITEM_ADDED_TO_CART instead. */
    public readonly [WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_ADDED_TO_CART] =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_ADDED_TO_CART;
}

export default WishlistsSdkEvents;
